import { getEntityHierarchyConfiguration } from 'src/redux/store/credentials'
import { useSelector } from 'react-redux'

export function useEntityHierarchyConfig() {
  return useSelector(getEntityHierarchyConfiguration)
}
